import React from "react";
import { ChangeLanguage } from "components/core/ChangeLanguage";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "context/auth-context";
import { Avatar, Dropdown } from "antd";
import { UserOutlined, DownOutlined } from "@ant-design/icons";
import { HashLink } from "react-router-hash-link";
import { FiX } from "react-icons/fi";
import { BrandLogo } from "components/ui";

export const NavSmallScreen = ({ toggle }: { toggle: () => void }) => {
  const { auth } = useAuth();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const normalizedPath = location.pathname.replace(/\/+$/, "");
  const hideFooterRoutes = ["/success", "/terminate", "/quota-full", "/security-terminate"];
  const hideContent = hideFooterRoutes.includes(normalizedPath);

  const handleGetStarted = () => {
    location.pathname === "/join-now" ? window.scrollTo(0, 0) : navigate("/join-now");
  };
  const items = [
    {
      key: "profile_1",
      className: "header-ant-dropdown-menu",
      label: <Link to={"/my-surveys"}>{t("home.headers.survey")}</Link>,
    },
    {
      key: "profile_2",
      className: "header-ant-dropdown-menu",
      label: <Link to={"/my-profile"}>{t("home.headers.profile")}</Link>,
    },
    {
      key: "profile_3",
      className: "header-ant-dropdown-menu",
      label: <Link to={"/my-referral"}>{t("home.headers.referral")}</Link>,
    },
    {
      key: "profile_4",
      className: `header-ant-dropdown-menu ${!auth?.isVirtualWalletOpen ? "hidden_menu" : ""}`,
      label: <Link to={"/virtual-wallet"}>{t("home.headers.virtual")}</Link>,
    },
    {
      key: "profile_5",
      className: "header-ant-dropdown-menu",
      label: <Link to={"/history"}>{t("home.headers.history")}</Link>,
    },
    {
      key: "profile_6",
      className: "header-ant-dropdown-menu",
      label: <Link to={"/unsubscribe"}>{t("home.headers.unsubscribe")}</Link>,
    },
    {
      key: "profile_7",
      className: "header-ant-dropdown-menu",
      label: (
        <Link
          to={"/logout"}
        // onClick={(event) => {
        //   event.preventDefault();
        //   // navigate(location.state || "/logout", { state: null });
        // }}
        >
          {t("home.headers.logout")}
        </Link>
      ),
    },
  ];
  const linkClass =
    "flex items-center h-12 px-3 text-base font-medium capitalize rounded-lg text-ink hover:bg-surface-hover transition-colors";

  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-surface animate-fadeIn">
      <div className="flex items-center justify-between h-[68px] px-4 border-b border-line">
        <BrandLogo className="w-auto h-8" />
        <div className="flex items-center gap-1">
          <ChangeLanguage />
          <button data-testid="nav-toggle-btn" className="zs-icon-btn" onClick={toggle} aria-label="Close menu">
            <FiX className="w-5 h-5" />
          </button>
        </div>
      </div>
      <ul className="flex flex-col flex-1 gap-1 p-4 overflow-y-auto">
        {!hideContent && (
          <>
            <li>
              <Link data-testid="m_home_link" to={"/"} className={linkClass}>
                Home
              </Link>
            </li>
            <li>
              <HashLink data-testid="faq_link" smooth to="/#feature" className={linkClass}>
                Features
              </HashLink>
            </li>
            <li>
              <HashLink data-testid="contact_link" smooth to="/#contact" className={linkClass}>
                {t("home.footer.Contact")}
              </HashLink>
            </li>
          </>
        )}
        {auth ? (
          <li className="pt-3 mt-3 border-t border-line">
            <Dropdown menu={{ items }} placement="topLeft">
              <a onClick={(e) => e.preventDefault()} className={`${linkClass} gap-3`}>
                <Avatar size={32} icon={<UserOutlined />} className="!bg-primary-soft !text-primary-text" />
                Hi! {auth.name ? auth.name.split(" ")[0] : ""} <DownOutlined className="text-xs" />
              </a>
            </Dropdown>
          </li>
        ) : (
          <>
            {!hideContent && (
              <li className="pt-4 mt-auto">
                <button onClick={handleGetStarted} className="zs-btn zs-btn-primary zs-btn-lg zs-btn-block">
                  Get Started Now
                </button>
              </li>
            )}
          </>
        )}
      </ul>
    </div>
  );
};
